import { auth, type SchemaResponse } from "@/modules/api"
import { ECampaignType } from "@/modules/helpers/enum"
import type { CommentDraft,Draft, DraftGallery, Gallery } from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

export type UploadDraft = {
  draftGalleries: DraftGallery[]
  content: string
  potentialId: string
  campaignType: ECampaignType
  version: number
}

export type UpdateDraft = {
  draftGalleries?: DraftGallery[]
  content: string
  draftId?: string
  removeDraftGalleryIds?: string[]
}

export const submitDraft = async (data: UploadDraft) => {
  const { campaignType, ...dataSubmit } = data
  if (campaignType === ECampaignType.COST_PER_VIEW) {
    return await auth.post<SchemaResponse<Draft>>("/draft/cpv", dataSubmit)
  }
  if (campaignType === ECampaignType.AFFILIATE) {
    return await auth.post<SchemaResponse<Draft>>("/draft/affiliate", dataSubmit)
  }
  return await auth.post<SchemaResponse<Draft>>("/draft/create", dataSubmit)
}

export const deleteDraftAsset = (deleteGalleryIds: string[]) => {
  if (!deleteGalleryIds?.length) return true
  return auth.patch<SchemaResponse<null>>(`draft/delete`, {
    deleteGalleryIds
  })
}
export const updateDraft = async (data: UpdateDraft) => {
  const { draftId, ...body } = data
  return await auth.patch<SchemaResponse<Draft>>(`/draft/update/${draftId}`, body)
}
export const getLinkS3UploadDraft = async (draftGalleries: DraftGallery[]) => {
  return await auth.post<SchemaResponse<string[]>>("/draft/get-link-s3-galleries", {
    draftGalleries
  })
}

export const getDraftsByPotentialId = async (id?: string, kolSubmissionId?: string) => {
  return await auth.get<SchemaResponse<PagingSchema<Draft>>>(`v1/drafts/list`, {
    params: {
      potentialId: id,
      order: "ASC",
      kolSubmissionId
    }
  })
}

export const getDraftById = async (id?: string) => {
  return await auth.get<SchemaResponse<Draft>>(`/draft/${id}`)
}
export const getAllCommentByParentId = async (id?: string) => {
  return await auth.get<SchemaResponse<PagingSchema<CommentDraft>>>(
    `/comment/get-by-parent-comment/`,
    {
      params: {
        parentId: id,
        take: 100,
        page: 1
      }
    }
  )
}

export const getAllCommentByDraftId = async (id?: string) => {
  return await auth.get<SchemaResponse<PagingSchema<CommentDraft>>>(`/comment/draftId/${id}`, {
    params: {
      take: 200,
      page: 1
    }
  })
}

export type CommentCreate = {
  content: string
  parentId?: string
  draftId?: string
  commentGalleries?: Gallery[]
}

export const createComment = async (data: CommentCreate) => {
  return await auth.post<SchemaResponse<{ linkS3CommentGalleries: string[] }>>(
    `/comment/create`,
    data
  )
}

export const submitLinkDraft = async (draftId?: string, submitUrl?: string) => {
  return await auth.patch<SchemaResponse<null>>(`/draft/submit-url`, {
    submitUrl,
    draftId
  })
}
export const submitLinkDraftCPV = async (draftId?: string, submitUrl?: string) => {
  return await auth.patch<SchemaResponse<null>>(`/draft/cpv/submit-url`, {
    submitUrl,
    draftId
  })
}
export const submitLinkDraftTAP = async (draftId?: string, submitUrl?: string) => {
  return await auth.patch<SchemaResponse<null>>(`/draft/affiliate/submit-url`, {
    submitUrl,
    draftId
  })
}

export const updateCodeDraftTAP = async (draftId?: string, codeAds?: string) => {
  return await auth.patch<SchemaResponse<null>>(`/draft/code-ads`, {
    codeAds,
    draftId
  })
}

export const submitLinkDraftTAPHighGMV = async ({
  submitUrl,
  kolSubmissionId,
  potentialId,
  version,
  codeAds
}: {
  submitUrl?: string
  kolSubmissionId?: string
  potentialId?: string
  version: number
  codeAds?: string
}) => {
  return await auth.patch<SchemaResponse<null>>(`/draft/affiliate/priority/submit-url`, {
    submitUrl,
    kolSubmissionId,
    potentialId,
    version,
    codeAds
  })
}
